<template>
    <main class="information_component-container">
        <h1>{{translate('about_program')}}</h1>
        <p v-html="translate(codeContent)"/>
        <div class="navi-btns">
            <div @click="$router.go(-1)" class="back-btn"><span>{{translate("back_btn")}}</span></div>
        </div>
    </main>
</template>

<script>

    export default {
        name: "AboutProgram",
        data() {
          return {
              codeContent: "about_program_content"
          }
        },
        methods: {
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },
        }
    }
</script>